// extracted by mini-css-extract-plugin
export default {"requestBox":"CompanyRequest_requestBox__rwkWf","buttonBox":"CompanyRequest_buttonBox__i7Q4j"};